(function() {
  define('bazemont/admins/edit',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('bazemontAdminsEdit', ['ngAnimate', 'ui.bootstrap']).component('bazemontAdminsEdit', {
      template: '<a href="" ng-click="$ctrl.openModal()" ng-transclude></span>',
      transclude: true,
      bindings: {
        user: '<'
      },
      require: {
        bazemontAdminsListCtrl: '^^bazemontAdminsList'
      },
      controller: [
        '$uibModal', function($uibModal) {
          var vm;
          vm = this;
          vm.openModal = function() {
            var modal;
            modal = $uibModal.open({
              templateUrl: '/assets/javascripts/bazemont/admins/edit.html',
              controllerAs: '$ctrl',
              bindToController: true,
              backdrop: 'static',
              resolve: {
                data: {
                  user: vm.user,
                  bazemontAdminsListCtrl: vm.bazemontAdminsListCtrl
                }
              },
              controller: [
                '$uibModalInstance', '$timeout', '$http', '$scope', '$window', 'data', 'Admin', 'TlhArrayService', 'TlhNotificationService', function($uibModalInstance, $timeout, $http, $scope, $window, data, Admin, TlhArrayService, TlhNotificationService) {
                  var emailIsAlreadyUsed, getSelectedPages, isUserPage, loadPageMultiselect, mvm, preselectCategory, preselectRole, validateForm;
                  mvm = this;
                  mvm.$onInit = function() {
                    mvm.user = angular.copy(data.user) || {};
                    mvm.roles = data.bazemontAdminsListCtrl.roles;
                    mvm.categories = data.bazemontAdminsListCtrl.categories;
                    mvm.pages = data.bazemontAdminsListCtrl.pages;
                    mvm.rolesThatCanEditPages = ['association', 'commission', 'enterprise'];
                    mvm.rolesThanCanHaveCategory = ['association', 'commission'];
                    mvm.editPassword = !mvm.user.id;
                    preselectRole();
                    preselectCategory();
                    return loadPageMultiselect();
                  };
                  loadPageMultiselect = function() {
                    var contentPage, middlePage, sectionPage, subContentPage, userPages, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1, _ref2, _ref3, _results;
                    mvm.multiselectPages = [];
                    userPages = data.bazemontAdminsListCtrl.getUserPages(mvm.user);
                    if (mvm.pages) {
                      _ref = mvm.pages;
                      _results = [];
                      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        sectionPage = _ref[_i];
                        mvm.multiselectPages.push({
                          title: '<strong>' + sectionPage.title + '</strong>',
                          group: true,
                          disabled: true
                        });
                        _ref1 = sectionPage.children;
                        for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
                          middlePage = _ref1[_j];
                          mvm.multiselectPages.push({
                            title: '<strong>' + middlePage.title + '</strong>',
                            group: true,
                            disabled: true
                          });
                          _ref2 = middlePage.children;
                          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
                            contentPage = _ref2[_k];
                            if (contentPage.children && contentPage.children.length > 0) {
                              mvm.multiselectPages.push({
                                title: '<strong>' + contentPage.title + '</strong>',
                                group: true,
                                disabled: true
                              });
                              _ref3 = contentPage.children;
                              for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
                                subContentPage = _ref3[_l];
                                mvm.multiselectPages.push({
                                  page: subContentPage,
                                  title: subContentPage.title,
                                  checked: isUserPage(userPages, subContentPage.id)
                                });
                              }
                              mvm.multiselectPages.push({
                                group: false
                              });
                            } else {
                              mvm.multiselectPages.push({
                                page: contentPage,
                                title: contentPage.title,
                                checked: isUserPage(userPages, contentPage.id)
                              });
                            }
                          }
                          mvm.multiselectPages.push({
                            group: false
                          });
                        }
                        _results.push(mvm.multiselectPages.push({
                          group: false
                        }));
                      }
                      return _results;
                    }
                  };
                  isUserPage = function(userPages, pageId) {
                    var result, userPage, _i, _len;
                    result = false;
                    for (_i = 0, _len = userPages.length; _i < _len; _i++) {
                      userPage = userPages[_i];
                      if (userPage.page.id === pageId) {
                        result = true;
                        break;
                      }
                    }
                    return result;
                  };
                  preselectRole = function() {
                    var role, _i, _len, _ref, _results;
                    if (mvm.user && mvm.user.roles && mvm.user.roles.length > 0) {
                      _ref = mvm.roles;
                      _results = [];
                      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        role = _ref[_i];
                        if (role.id === mvm.user.roles[0].id) {
                          _results.push(mvm.userRole = role);
                        } else {
                          _results.push(void 0);
                        }
                      }
                      return _results;
                    }
                  };
                  preselectCategory = function() {
                    var category, userCategory, _i, _len, _ref, _results;
                    userCategory = data.bazemontAdminsListCtrl.getUserCategory(mvm.user);
                    if (userCategory && userCategory.category && mvm.categories && mvm.categories.length > 0) {
                      _ref = mvm.categories;
                      _results = [];
                      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        category = _ref[_i];
                        if (category.id === userCategory.category.id) {
                          _results.push(mvm.userCategory = category);
                        } else {
                          _results.push(void 0);
                        }
                      }
                      return _results;
                    }
                  };
                  validateForm = function() {
                    return mvm.form.email.$setValidity('emailIsAlreadyUsed', !emailIsAlreadyUsed(mvm.user));
                  };
                  emailIsAlreadyUsed = function(user) {
                    var result;
                    result = false;
                    return result;
                  };
                  getSelectedPages = function() {
                    var multiselectPage, selectedPage, _i, _len, _ref;
                    selectedPage = [];
                    if (mvm.multiselectPages) {
                      _ref = mvm.multiselectPages;
                      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        multiselectPage = _ref[_i];
                        if (multiselectPage.checked) {
                          selectedPage.push(multiselectPage.page);
                        }
                      }
                    }
                    return selectedPage;
                  };
                  mvm.isAdmin = function(user) {
                    return data.bazemontAdminsListCtrl.isAdmin(user);
                  };
                  mvm.canEditPages = function(userRole) {
                    return userRole && mvm.rolesThatCanEditPages.indexOf(userRole.name) !== -1;
                  };
                  mvm.canHaveCategory = function(userRole) {
                    return userRole && mvm.rolesThanCanHaveCategory.indexOf(userRole.name) !== -1;
                  };
                  mvm.setUserRole = function() {
                    return mvm.user.roles = [mvm.userRole];
                  };
                  mvm.setEditPassword = function(editPassword) {
                    mvm.editPassword = editPassword;
                    if (!editPassword) {
                      return mvm.user.password = '';
                    } else {
                      return $timeout(function() {
                        return document.getElementById('password').focus();
                      });
                    }
                  };
                  mvm.submit = function() {
                    validateForm();
                    if (mvm.form.$valid && !mvm.submitting) {
                      TlhNotificationService.info({
                        message: 'Enregistrement en cours...',
                        delay: false
                      });
                      mvm.submitting = true;
                      return $http.post('/api/admin/admins', {
                        user: mvm.user,
                        password: mvm.user.password,
                        role: mvm.userRole,
                        category: mvm.userCategory,
                        pages: getSelectedPages()
                      }).then(function(response) {
                        TlhNotificationService.success({
                          message: 'Enregistrement terminé',
                          replaceMessage: true
                        });
                        return $uibModalInstance.close(mvm.user);
                      })["catch"](function(error) {
                        var message;
                        console.error(error);
                        message = "L'enregistrement a échoué :<br>";
                        message += error.data ? error.data : "Erreur inattendue, veuillez contacter l'administrateur.";
                        return TlhNotificationService.error({
                          message: message,
                          replaceMessage: true,
                          delay: false
                        });
                      })["finally"](function() {
                        return mvm.submitting = false;
                      });
                    }
                  };
                  mvm.close = function() {
                    return $uibModalInstance.dismiss();
                  };
                }
              ]
            });
            return modal.result.then(function(user) {
              return vm.bazemontAdminsListCtrl.resetList();
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=edit.js.map
;
